var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1201_1117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.424 0.746453C13.9427 0.2651 13.3027 0 12.6218 0H2.54866C1.86791 0 1.2278 0.2651 0.746453 0.746453C0.2651 1.22791 0 1.86791 0 2.54866V7.43848C0 8.11922 0.2651 8.75933 0.746453 9.24069C1.2278 9.72204 1.86791 9.98714 2.54866 9.98714H3.26129C3.17818 9.78613 3.13592 9.57366 3.13592 9.35524V9.1404C3.13592 9.01276 3.14478 8.88643 3.16208 8.76182H2.54855C1.81885 8.76182 1.22521 8.16818 1.22521 7.43848V2.54866C1.22521 1.81896 1.81885 1.22532 2.54855 1.22532H12.6217C13.3514 1.22532 13.9451 1.81896 13.9451 2.54866V7.43848C13.9451 8.16818 13.3514 8.76182 12.6217 8.76182H12.0082C12.0255 8.88654 12.0343 9.01276 12.0343 9.1404V9.35524C12.0343 9.57366 11.9921 9.78613 11.909 9.98714H12.6216C13.3024 9.98714 13.9425 9.72204 14.4238 9.24069C14.9052 8.75933 15.1703 8.11922 15.1703 7.43848V2.54866C15.1703 1.86791 14.9052 1.2278 14.4238 0.746453H14.424Z",
    fill: "url(#paint0_linear_1201_1117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58518 6.99164C8.65333 6.99164 9.51923 6.12574 9.51923 5.05759C9.51923 3.98944 8.65333 3.12354 7.58518 3.12354C6.51703 3.12354 5.65112 3.98944 5.65112 5.05759C5.65112 6.12574 6.51703 6.99164 7.58518 6.99164Z",
    fill: "url(#paint1_linear_1201_1117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30435 7.42139H8.56427C8.2661 7.55842 7.93432 7.63623 7.58514 7.63623C7.23596 7.63623 6.90559 7.55831 6.60601 7.42139H5.86594C5.04643 7.42139 4.36114 7.9946 4.18866 8.76191C4.16132 8.88371 4.14673 9.01037 4.14673 9.14049V9.35533C4.14673 9.66734 4.36871 9.92779 4.66331 9.98723C4.7047 9.99555 4.74761 9.99998 4.79149 9.99998H10.3788C10.4227 9.99998 10.4655 9.99555 10.507 9.98723C10.8016 9.92779 11.0236 9.66734 11.0236 9.35533V9.14049C11.0236 9.01037 11.0091 8.88371 10.9816 8.76191C10.8091 7.9946 10.1239 7.42139 9.30435 7.42139Z",
    fill: "url(#paint2_linear_1201_1117)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1201_1117",
    x1: 7.58513,
    y1: 0,
    x2: 7.58513,
    y2: 9.98714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1201_1117",
    x1: 7.58518,
    y1: 3.12354,
    x2: 7.58518,
    y2: 6.99164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1201_1117",
    x1: 7.58514,
    y1: 7.42139,
    x2: 7.58514,
    y2: 9.99998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDFB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1201_1117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.1706,
    height: 10,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.91a721ad03201ac08aa9e7ebde816960.svg";
export { ForwardRef as ReactComponent };